module.exports = __webpack_public_path__ + "img/linanbanner3.4b759195.jpg";